/**
 * LE SEUL FORMATAGE DES NOMBRES du dossier, a la francaise (virgule decimale,
 * pas de separateur de milliers) : poids, constantes, doses, quantites. Tout
 * nombre qui s'affiche ou se pre-remplit dans un champ passe par ici, jamais
 * par `String(n)` ni `n.toFixed()`, qui ecrivent « 28.6 ». Teste par
 * `nombre.test.mjs`.
 */

/** « 28,6 », « 0,4 », « 1,33 », « 12 » : deux decimales au plus ; une quantite minuscule en garde trois. */
export function nombreEnTexte(n: number): string {
  const decimales = n !== 0 && Math.abs(n) < 0.1 ? 3 : 2;
  return n.toLocaleString('fr-BE', { maximumFractionDigits: decimales, useGrouping: false });
}

/** « 28,6 kg ». */
export function kiloEnTexte(kg: number): string {
  return `${nombreEnTexte(kg)} kg`;
}
